import { LoadsJobFilters } from '~types/loadsFilters';
import { approvalFilterToBoolean } from '~utils/filters/approval-filter-utils';

import { APPROVALS_JOB_STATES } from './constants';
import type { FilesQueryFilters } from './FilesQueryContext';

// The job states narrow loads by the state of the job each load belongs to, which is
// separate from the load's own state.
export function makeLoadsJobFilters(filters: FilesQueryFilters): LoadsJobFilters {
  return {
    assigned: true,
    billingApproved: approvalFilterToBoolean(filters.loadApprovalStatus),
    driverIds: filters.driverIds,
    dropoffSiteIds: filters.dropoffSiteIds,
    pickupSiteIds: filters.pickupSiteIds,
    states: filters.jobStates?.length ? filters.jobStates : APPROVALS_JOB_STATES,
    ticketPotentialDuplicate: filters.ticketPotentialDuplicate?.length
      ? filters.ticketPotentialDuplicate[0] === 'true'
      : undefined,
    vendorAccountIds: filters.vendorAccountIds,
  };
}
